import React, { useCallback } from "react";
import { VerifyRecaptchaApiService } from "../../services/recaptcha/verify-recaptcha-api.service";
import { VerifyRecaptchaFilter } from "../../models/recaptcha/verify-recaptcha-filter";
import { Grid } from "@mui/material";

interface Props {
  notifyParent: (verfied: boolean) => void;
  action: string;
  children: React.ReactNode;
  setLoading?: (loading: boolean) => void;
  setError?: (error: string) => void;
}

const Recaptcha = ({ notifyParent, action, children, setLoading, setError }: Props) => {
  const handleRecaptcha = useCallback(
    async (recaptchaToken: string) => {
      try {
        const response = await new VerifyRecaptchaApiService().loadItems({
          token: recaptchaToken,
        } as VerifyRecaptchaFilter);
        notifyParent(response.items[0].success);
      } catch (error) {
        notifyParent(false);
      } finally {
        setLoading && setLoading(false);
      }
    },
    [notifyParent, setLoading]
  );

  const preHandleRecaptcha = useCallback(async () => {
    if ((window as any).grecaptcha) {
      setLoading && setLoading(true);
      try {
        const grecaptcha = (window as any).grecaptcha;
        const token = await grecaptcha.enterprise.execute(`${import.meta.env.VITE_RECAPTCHA_API_KEY}`, {
          action: action,
        });
        handleRecaptcha(token);
      } catch (error) {
        setError && setError(error as string);
        setLoading && setLoading(false);
      }
    }
  }, [action, handleRecaptcha, setLoading, setError]);

  return (
    <>
      <Grid
        onClick={(e) => {
          e.preventDefault();
          preHandleRecaptcha();
        }}
        style={{ cursor: "pointer" }}
      >
        {children}
      </Grid>
      {/* <Dialog open={open}>
        <LoadingOverlay loading={loading}>
          <DialogContent style={{ display: "flex", width: "400px", height: "120px", justifyContent: "center" }}>
            {error && <Alert severity="error">{error}</Alert>}
            <ReCAPTCHA
              sitekey={"6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"}
              onChange={handleRecaptcha}
            />
          </DialogContent>
        </LoadingOverlay>
      </Dialog> */}
    </>
  );
};
export default Recaptcha;
